// 应用整体样式配置文件
import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles/createMuiTheme" {
    interface Theme {
        constant: {
            drawerWidth: number,
        }
    }
    // allow configuration using `createMuiTheme`
    interface ThemeOptions {
        constant?: {
            drawerWidth: number,
        }
    }
}

const theme = createMuiTheme({
    constant: {
        drawerWidth: 260,
    },
    palette: {
        primary: {
            main: "#1765bc",
        },
    },
    zIndex: {
        modal: 6400,
        tooltip: 16401,
        snackbar: 7400,
    },
})

export default theme
